import { combineReducers } from "redux";
import suggestionReducer from "./reducer-suggestions";
import loginReducer from "./reducer-login";
import messageReducer from "./messageReducer";
import eventReducer from "./reducer-events";
import ownEventReducer from "./reducer-ownevents";
import dealReducer from "./reducer-deals";
import albumReducer from "./reducer-album";
import postReducer from "./reducer-post";
import rewardsReducer from "./reducer-rewards";
import visitorReducer from "./reducer-visitor";
import businessProfileReducer from "./reducer-businessprofile";
import progressReducer from "./reducer-progress";
import activityReducer from "./reducer-activity";
import appointmentReducer from "./reducer-appointment";
import orderReducer from "./reducer-order";
import myAccountReducer from "./reducer-myAccount";
import heatSpotReducer from "./heatspotReducer";
import chartReducer from "./reducer-chartDetail";
import checkInDetailReducer from "./reducer-checkInDetail";
import dealClaimedReducer from "./reducer-dealclaimedDetail";
import planReducer from "./reducer-plans";
import potentailReducer from "./reducer-potentialReach";
import liveChatReducer from "./liveChatReducer";
import cardReducer from "./reducer-card";
import accountDetail from "./reducer-payment";
import loaderReducer from "./loaderReducer";
import { routerReducer } from "react-router-redux";

let allReducers = combineReducers({
  suggestions: suggestionReducer,
  loginResponse: loginReducer,
  events: eventReducer,
  messageReducer: messageReducer,
  rewards: rewardsReducer,
  deals: dealReducer,
  albums: albumReducer,
  post: postReducer,
  progress: progressReducer,
  visitors: visitorReducer,
  myAccount: myAccountReducer,
  activity: activityReducer,
  businessProfile: businessProfileReducer,
  chartDetail: chartReducer,
  ownEvents: ownEventReducer,
  checkInDetail: checkInDetailReducer,
  dealClaimedDetail: dealClaimedReducer,
  heatSpotReducer: heatSpotReducer,
  plans: planReducer,
  potentialCount: potentailReducer,
  liveChatReducer: liveChatReducer,
  card: cardReducer,
  accountDetail,
  loaderReducer: loaderReducer,
  router: routerReducer,
  appointmentReducer: appointmentReducer,
  orderReducer: orderReducer,
  // drawer
});
const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    state = undefined;
    state = {
      messageReducer: {
        connection: true,
      },
      albums: {
        album: [],
      },
    };
  }
  return allReducers(state, action);
};
export default rootReducer;
